module.exports = __webpack_public_path__ + "img/payment_success_background.5bdb6ef5.jpg";